import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorFlagTitle: {
		id: 'tmp-feature-toggle.controllers.use-show-flags.error-flag-title',
		defaultMessage: 'Something went wrong.',
		description:
			'Title for the error flag when API fails to update a feature or fetch feature list',
	},
	errorFlagDescription: {
		id: 'tmp-feature-toggle.controllers.use-show-flags.error-flag-description',
		defaultMessage: 'Try again, or manage these features via project settings.',
		description:
			'Description for the error flag when API fails to update a feature or fetch feature list',
	},
	errorFlagSettingsLink: {
		id: 'tmp-feature-toggle.controllers.use-show-flags.error-flag-settings-link',
		defaultMessage: 'Go to settings',
		description: 'Settings link',
	},
});
